module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-bottom-ties-remnants.d7b79052.png";